var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCohortBadge = function SvgCohortBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    d: "M3.106 0h12.739c.072 0 .134.047.15.116a.14.14 0 0 1-.084.164c-1.249.56-1.952 1.875-1.952 3.047v12.525a.68.68 0 0 1-.238.53L7.397 21.8a.826.826 0 0 1-1.083-.005L.232 16.382A.68.68 0 0 1 0 15.858V2.939C0 1.321 1.396 0 3.106 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3 9 3.536-3.536L10.07 9l-3.535 3.536z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3 13 3.536-3.536L10.07 13l-3.535 3.536z"
  })));
};
export { SvgCohortBadge as ReactComponent };
export default __webpack_public_path__ + "fonts/cohort-badge-52dee9979778480e2915145ab03965d3.svg";